import { Dialog, useMediaQuery } from '@material-ui/core'
import styled from 'styled-components'
import { ColumnSpacer } from '../../shared/ui/Spacer'
import WhiteButton from '../../shared/ui/WhiteButton'
import useSecondaryDialogState from './useSecondaryDialogState'
import { X } from '@styled-icons/heroicons-solid/X'
// import { SwitchHorizontal } from '@styled-icons/heroicons-outline/SwitchHorizontal'

import CartItem from './CartItem'
import PriceInput from './PriceInput'
import { SECONDARY_ACTION } from '../../../atoms/SecondaryDialog'
import { useEffect, useState } from 'react'
import HintLabel from '../../global/HintLabel'

// ============================ React Component ================================

const SecondaryDialog = (): JSX.Element => {
  const state = useSecondaryDialogState()

  const fullscreen = useMediaQuery('(max-width: 43em)')

  const [showNowActionButton, setShowNowActionButton] = useState(false)

  useEffect(() => {
    switch (state.secondaryAction.type) {
      case SECONDARY_ACTION.BUY:
        setShowNowActionButton(state.isAnyListingExisting)
        break
      case SECONDARY_ACTION.SELL:
        setShowNowActionButton(state.isAnyOfferExisting)
        break
      default:
        // Reset to default to highlight the right button.
        state.setPrice(0)
    }
  }, [state, state.secondaryAction.type, state.isAnyListingExisting, state.isAnyOfferExisting])

  return (
    <Dialog
      open={state.isDialogOpen}
      fullScreen={fullscreen}
      disableScrollLock={false}
      PaperProps={{
        style: {
          backgroundColor: '#101010',
          borderRadius: fullscreen ? 0 : 30,
          borderWidth: fullscreen ? 0 : 1,
          borderColor: '#262626',
          borderStyle: 'solid',
          height: !fullscreen ? '85vh' : '100%',
          maxHeight: !fullscreen ? `650px` : '100vh',
          width: !fullscreen ? '50vw' : '100vw',
        },
      }}
    >
      <Column>
        <CloseButton
          onClick={() => {
            state.setSecondaryAction({ type: SECONDARY_ACTION.NONE, video: undefined })
          }}
        />
        <DialogTitleLabel>{state.title}</DialogTitleLabel>
        <InputSection>
          <PriceInput onValueChange={state.setPrice} focus={state.isDialogOpen && !fullscreen} />
          <ColumnSpacer space="5px" />
          <HintLabel
            hint={state.hintLabel}
            hintInfo={state.hintInfos}
            fontSize={'15px'}
            fontWeight={'700'}
            size={'25px'}
          />
        </InputSection>
        <BottomSection>
          <CartItem
            videoTitle={state.cartItemDetails.title}
            creatorName={state.cartItemDetails.creatorName}
            videoThumbnailUrl={state.cartItemDetails.thumbnailUri}
            floorPrice={state.cartItemFloorPrice.toString()}
          />
          <ColumnSpacer space="20px" />
          <ButtonRow>
            <WhiteButton
              whitened={state.price > 0}
              label={state.laterActionLabel}
              disabled={state.price <= 0}
              onClick={state.guardedLaterAction}
            />
            {showNowActionButton && (
              <WhiteButton
                whitened={state.price == 0}
                disabled={state.price > 0}
                label={state.nowActionLabel}
                onClick={state.guardedNowAction}
              />
            )}
          </ButtonRow>
        </BottomSection>
      </Column>
    </Dialog>
  )
}

export default SecondaryDialog

// ============================ Styled Components ==============================

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  width: calc(100% + 40px);
  height: 50px;
`

const Column = styled.div`
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding-bottom: 25px;
  padding-left: 10px;
  padding-right: 10px;
`

const DialogTitleLabel = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #fff;
`

const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 80px);
  margin: 0 40px;
  align-items: center;
`

const CloseButton = styled(X)`
  color: white;
  position: absolute;
  left: 20px;
  width: 30px;

  &:hover {
    cursor: pointer;
  }
`
